export const API_ENDPOINTS = {
    login: '/login',
    refreshToken: '/renewToken',
    dashboardData: '/dashboardData',
    part: {
        categories: '/partCategory',
        list: '/part',
        byDevice: id => `/part/byDevice/${id}`,
        add: '/part',
        duplicate: id => `/part/${id}/duplicate`,
        delete: id => `/part/${id}`,
        deletePartCategory: id => `/partCategory/${id}`,
        edit: id => `/part/${id}`,
    },
    partSku: {
        list: '/partSku',
        add: '/partSku',
        listByRepair: id => `/partSku/listByRepair/${id}`,
        listByDevice: deviceId => `/partSku/listByDevice/${deviceId}`,
        delete: id => `/partSku/${id}`,
        edit: id => `/partSku/${id}`,
    },
    partParameter: {
        list: '/partParameter',
        add: '/partParameter',
        delete: id => `/partParameter/${id}`,
        edit: id => `/partParameter/${id}`,
    },
    repairs: {
        add: '/repair',
        list: '/repair/list',
        get: id => `/repair/${id}`,
        edit: id => `/repair/${id}`,
        cancel: id => `/repair/${id}/cancel`,
        addNote: id => `/repair/${id}/addNote`,
        addRepairItem: id => `/repair/${id}/addRepairItem`,
        addPart: id => `/repair/${id}/addPart`,
        removePart: id => `/repair/${id}/removePart`,
        taskDiscount: id => `/repair/${id}/taskDiscount`,
        start: id => `/repair/${id}/start`,
        startWork: id => `/repair/${id}/startWork`,
        stopWork: id => `/repair/${id}/stopWork`,
        logWork: id => `/repair/${id}/logWork`,
        taskStatus: id => `/repair/${id}/taskStatus`,
        notifyCompletion: id => `/repair/${id}/notifyCompletion`,
        intakeProtocolPdf: id => `/repair/${id}/intakeProtocolPdf`,
        invoicePdf: id => `/repair/${id}/invoicePdf`,
        finishRepairState: id => `/repair/${id}/finish`,
        delete: id => `/repair/${id}`,
    },
    sms: {
        sendTest: '/sms/sendTest'
    },
    appSettings: {
        current: '/appSettings',
        update: '/appSettings'
    },
    device: {
        listCategories: '/device/listCategories',
        list: '/device',
        add: '/device',
        base: '/device',
        category: 'device/category',
        delete: id => `device/category/${id}`,
        listRepairsByDevice: '/device/listRepairsByDevice',
        repairTimes: '/device/repairTimes'
    },
    repairCatalog: {
        list: '/repairCatalog',
        add: '/repairCatalog',
        delete: id => `/repairCatalog/${id}`,
        edit: id => `/repairCatalog/${id}`,
    },
    diagnosticCatalog: {
        list: '/diagnosticCatalog',
        add: '/diagnosticCatalog',
        delete: id => `/diagnosticCatalog/${id}`,
        edit: id => `/diagnosticCatalog/${id}`,
    },
    partLog: {
        list: '/partLog',
    },
    user: {
        create: '/user',
        list: '/user',
        resetPassword: '/resetPassword',
        setNewPassword: '/setNewPassword',
        delete: id => `/user/${id}`,
        update: id => `/user/${id}`,
        updateSectionViewMode: '/user/preferences/view-mode'
    },
    partOrders: {
        list: '/partOrder',
        add: '/partOrder',
        markDelivered: id => `/partOrder/${id}/markDelivered`,
        delete: id => `/partOrder/${id}`,
        get: id => `/partOrder/${id}`
    },
    buyback: {
        list: '/buyback',
        add: '/buyback',
        delete: id => `/buyback/${id}`,
        get: id => `/buyback/${id}`,
        update: id => `/buyback/${id}`
    },
    buybacks: {
        list: '/buyback',
        create: '/buyback',
        detail: id => `/buyback/${id}`,
        update: id => `/buyback/${id}`,
        delete: id => `/buyback/${id}`,
        saveDonorDiagnostics: id => `/buyback/${id}/donorDiagnostics`,
        stockDonorDiagnostics: id => `/buyback/${id}/donorDiagnostics/stock`,
        uploadPhotos: id => `/buyback/${id}/photos`,
        deletePhoto: (id, photoId) => `/buyback/${id}/photos/${photoId}`
    },
    sales: {
        list: '/sale',
        create: '/sale',
        detail: id => `/sale/${id}`,
        update: id => `/sale/${id}`,
        markSold: id => `/sale/${id}/markSold`,
        delete: id => `/sale/${id}`,
        createFromBuyback: id => `/sale/fromBuyback/${id}`,
        uploadPhotos: id => `/sale/${id}/photos`,
        deletePhoto: (id, photoId) => `/sale/${id}/photos/${photoId}`
    },
    webInquiry: {
        list: '/webInquiry',
        summary: '/webInquiry/summary',
        settings: '/webInquiry/settings',
        calendar: '/webInquiry/calendar',
        detail: id => `/webInquiry/${id}`,
        delete: id => `/webInquiry/${id}`,
        customerMatches: id => `/webInquiry/${id}/customerMatches`,
        status: id => `/webInquiry/${id}/status`,
        reschedule: id => `/webInquiry/${id}/reschedule`,
        note: id => `/webInquiry/${id}/note`,
        reply: id => `/webInquiry/${id}/reply`,
        customer: id => `/webInquiry/${id}/customer`,
        link: id => `/webInquiry/${id}/link`,
        markUnread: id => `/webInquiry/${id}/markUnread`,
        anonymize: id => `/webInquiry/${id}/anonymize`,
        assign: id => `/webInquiry/${id}/assign`
    },
    emailQueue: {
        list: '/emailQueue',
        summary: '/emailQueue/summary',
        detail: id => `/emailQueue/${id}`,
        retry: id => `/emailQueue/${id}/retry`,
        sendNow: id => `/emailQueue/${id}/sendNow`,
        cancel: id => `/emailQueue/${id}/cancel`,
        retryFailed: '/emailQueue/retryFailed'
    },
    customer: {
        list: '/customer',
        add: '/customer',
        delete: id => `/customer/${id}`,
        get: id => `/customer/${id}`,
        update: id => `/customer/${id}`
    }
};
